import _classCallCheck from "/Users/andrewcaluzzi/workspace/deployments-node-20/builds/universe/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/andrewcaluzzi/workspace/deployments-node-20/builds/universe/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/andrewcaluzzi/workspace/deployments-node-20/builds/universe/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/andrewcaluzzi/workspace/deployments-node-20/builds/universe/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/andrewcaluzzi/workspace/deployments-node-20/builds/universe/node_modules/@babel/runtime/helpers/esm/inherits";
import { AbstractMatrix } from '../matrix';
var WrapperMatrix2D = /*#__PURE__*/function (_AbstractMatrix) {
  _inherits(WrapperMatrix2D, _AbstractMatrix);
  function WrapperMatrix2D(data) {
    var _this;
    _classCallCheck(this, WrapperMatrix2D);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(WrapperMatrix2D).call(this));
    _this.data = data;
    _this.rows = data.length;
    _this.columns = data[0].length;
    return _this;
  }
  _createClass(WrapperMatrix2D, [{
    key: "set",
    value: function set(rowIndex, columnIndex, value) {
      this.data[rowIndex][columnIndex] = value;
      return this;
    }
  }, {
    key: "get",
    value: function get(rowIndex, columnIndex) {
      return this.data[rowIndex][columnIndex];
    }
  }]);
  return WrapperMatrix2D;
}(AbstractMatrix);
export { WrapperMatrix2D as default };